import React from "react";
import {CardContent, CardHeader, Button, Alert, Typography} from "@mui/material";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {deleteHoliday} from "../../../Redux/Action";
import DialogActions from "@mui/material/DialogActions";
import {setModal} from "../../../../../Common/App";
import {DialogCard} from "../../../../../../Components/Cards/DialogCard";
import {Loader} from "../../../../../../Components";
import dayjs from 'dayjs';

export const DeleteHolidayModal = ({holiday, group}) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const holidayData = group || (holiday ? { items: [holiday], name: holiday.holiday_name } : null);
    const isGroup = group && group.items && group.items.length > 1;
    const startDate = holidayData ? dayjs(holidayData.items[0].holiday_date) : null;
    const endDate = holidayData && holidayData.items.length > 1 ? dayjs(holidayData.items[holidayData.items.length - 1].holiday_date) : startDate;
    const dateRange = startDate && endDate && !startDate.isSame(endDate, 'day')
        ? `${startDate.format('MMMM D, YYYY')} - ${endDate.format('MMMM D, YYYY')}`
        : startDate ? startDate.format('MMMM D, YYYY') : '';

    const handleSubmit = async () => {
        if (!holidayData || !holidayData.items || holidayData.items.length === 0) return;

        setIsLoading(true);
        
        const deletePromises = holidayData.items.map(item => 
            deleteHoliday({dispatch, id: item.id})
        );

        await Promise.all(deletePromises).then((results) => {
            const allSuccess = results.every(res => res.success);
            if (allSuccess) {
                dispatch(setModal({component:null, open:false}));
            }
            setIsLoading(false);
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={"Delete Holiday"}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    You are about to delete the holiday <strong>"{holidayData?.name}"</strong>
                    {dateRange && (
                        <> scheduled for <strong>{dateRange}</strong></>
                    )}
                    {isGroup && (
                        <> ({holidayData.items.length} day{holidayData.items.length > 1 ? 's' : ''})</>
                    )}.
                </Typography>
                <Alert severity="warning">
                    This action cannot be undone. Are you sure you want to proceed?
                </Alert>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2, justifyContent: 'flex-end' }}>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'error'} onClick={ handleSubmit }>Delete</Button>
            </DialogActions>
        </DialogCard>
    )
}

